import * as React from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  value: string
  message: string
  errored: boolean
  ok: boolean
}

const CellContent = ({ value, message, errored, ok }: Props) => {
  const [open, toggle] = useToggle(false)

  if (ok) {
    return (
      <Box alignItems="center" inline>
        <Text.Normal>{value || '-'}</Text.Normal>
      </Box>
    )
  }

  const type = errored ? 'wrong' : 'accent'
  const iconColor = errored ? 'radicalRed1000' : 'champagne800'
  const fontColor = errored ? 'radicalRed1000' : 'champagne1000'

  const icon = errored ? (
    <Icon.Medium icon="cross-circle" color={iconColor} />
  ) : (
    <Icon.Medium icon="alert" color={iconColor} />
  )

  return (
    <Tooltip attachment="bottom center" type={type} size="small" open={open} toggle={toggle}>
      <Box flexDirection="row" alignItems="center" justifyContent="center" gap="s6" inline>
        <Text.Normal color={fontColor}>{value || '-'}</Text.Normal>
        {icon}
      </Box>

      <span>{message}</span>
    </Tooltip>
  )
}

export default observer(CellContent)
